"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionUpatedCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../commands");
const CardHelper_1 = require("../utils/CardHelper");
const SubscriptionUpatedCard = (title, message) => {
    const card = CardHelper_1.CardHelper.newCard();
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        spacing: adaptivecards_1.Spacing.ExtraLarge,
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: title,
        size: adaptivecards_1.TextSize.Large,
        weight: adaptivecards_1.TextWeight.Bolder,
        color: adaptivecards_1.TextColor.Accent,
        wrap: true,
    }));
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: message,
        spacing: adaptivecards_1.Spacing.Medium,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    card.addItem(container);
    card.addAction((0, commands_1.DeleteCardAction)());
    return card;
};
exports.SubscriptionUpatedCard = SubscriptionUpatedCard;
//# sourceMappingURL=SubscriptionUpdatedCard.js.map